import clsx from 'clsx';
import type { ReactNode } from 'react';
import { Link } from 'react-router';

const variantStyles = {
  primaryClassName: 'text-green-900 bg-yellow-500 hover:bg-yellow-600',
  secondaryClassName: 'text-green-900 bg-green-200 hover:text-white hover:bg-green-600',
  accentClassName: 'text-white bg-green-600 hover:bg-green-500',
};

const sizeStyles = {
  smClassName: 'px-5 py-2.5 text-base',
  lgClassName: 'px-8 py-3.5 text-lg',
};

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'accent';
  size?: 'sm' | 'lg';
  href?: string;
  children?: ReactNode;
}

export function Button({
  variant = 'primary',
  size = 'lg',
  className,
  href,
  children,
  ...props
}: ButtonProps) {
  const cls = clsx(
    'font-medium relative leading-normal inline-flex items-center justify-center duration-300 ease-in-out rounded-full outline-none group',
    variantStyles[`${variant}ClassName`],
    sizeStyles[`${size}ClassName`],
    className,
  );

  return href ? (
    <Link to={href} className={cls}>
      {children}
    </Link>
  ) : (
    <button className={cls} {...props}>
      {children}
    </button>
  );
}
